import Esearcher from './Esearcher/index.js';

$(function () {
    var isInIframe = (window.location != window.parent.location) ? true : false;
    if (isInIframe) {
        return;
    }
    if (Cookies.get('__messages') !== undefined) {
        var e = Cookies.getJSON('__messages');
        Cookies.remove('__messages');
        var notifier = Esearcher.Ui.Notifier.getInstance();
        $.each(e, function (part, data) {
            $.each(data, function (a, text) {
                notifier.notify(text.replace(/&nbsp;/g, ' '), part);
            });
        });
    }

    const reminderChannel = typeof BroadcastChannel !== 'undefined'
        ? new BroadcastChannel('reminder-sync')
        : null;

    const broadcastReminder = (message) => {
        reminderChannel?.postMessage(message);
    };

    const showReminder = (reminder) => {
        if ($(`#reminder_${reminder.id}`).length) {
            return;
        }
        new PNotify({
            id: `#reminder_${reminder.id}`,
            title: reminder.title,
            text: reminder.html,
            hide: false,
            buttons: {
                closer: false,
                sticker: false,
            },
        });
    };

    const removeReminder = (id) => {
        PNotify.notices
            .filter((notice) => notice.options.id === `#reminder_${id}`)
            .forEach((notice) => notice.remove());
    };

    const bindReminderEvents = () => {
        bindDeactiveReminderEvent();
        bindDelay60ReminderEvent();
        bindSelectDelayEvent();
    };

    reminderChannel?.addEventListener('message', ({ data: message }) => {
        if (!message) {
            return;
        }
        if (message.type === 'reminder-show') {
            showReminder(message.reminder);
            bindReminderEvents();
        } else if (message.type === 'reminder-remove') {
            removeReminder(message.id);
        }
    });

    const polling = new Esearcher.Polling(
        'reminderService-getCurrentReminders',
        60000,
        (data) => {
            data.forEach((reminder) => {
                if (!$(`#reminder_${reminder.id}`).length) {
                    showReminder(reminder);
                    broadcastReminder({ type: 'reminder-show', reminder });
                }
            });
            bindReminderEvents();
        },
        true,
    );

    var connect = Esearcher.Connect.getInstance();
    connect.poll(polling);

    function bindDeactiveReminderEvent() {
        $(document).off('click', '[name=deactivate]');
        $(document).on('click', '[name=deactivate]', function (e) {
            var id = $(e.target).attr('data-id');
            $.ajax({
                url: '/reminder/disable/'+id,
                method: 'POST',
            }).done(function() {
                removeReminder(id);
                broadcastReminder({ type: 'reminder-remove', id: id });
                connect.runPolling('reminderService-getCurrentReminders');
            });
        });
    }

    function bindDelay60ReminderEvent() {
        $(document).off('click', '[name=delay60]');
        $(document).on('click', '[name=delay60]', function (e) {
           var id = $(e.target).attr('data-id');
           $.ajax({
               url: '/reminder/delay/60/'+id,
               method: 'POST'
           }).done(function() {
               removeReminder(id);
               broadcastReminder({ type: 'reminder-remove', id: id });
               connect.runPolling('reminderService-getCurrentReminders');
           });
        });
    }

    function bindSelectDelayEvent() {
        $(document).on('click', '[name=selectDelay]', function (e) {
            var parentDiv = $(this).parents('div.ui-pnotify');
            $(document).find('div.ui-pnotify').css('z-index', 100040);
            parentDiv.css('z-index', 110040);

        });

        $(document).off('click', '[name=delay]');
        $(document).on('click', '[name=delay]', function (e) {
            var target = e;
            var delay = $(e.target).attr('data-id');
            var id = $(e.target).attr('id');
            $.ajax({
               url: '/reminder/delay/'+delay+'/'+id,
               method: 'POST'
            }).done(function() {
                removeReminder(id);
                broadcastReminder({ type: 'reminder-remove', id: id });
                connect.runPolling('reminderService-getCurrentReminders');
            });
        });
    }
});
